/**
 * Formatting utilities
 */

/**
 * Formats a number as currency with European format
 * @param value - The number to format
 * @param currency - Currency symbol (default: '€')
 * @returns Formatted currency string (e.g., "1.234,56 €")
 */
export function formatCurrency(value: number, currency: string = '€'): string {
    const formatted = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);

    // Replace EUR symbol with provided currency
    return formatted.replace('EUR', currency).trim();
}

/**
 * Formats a number with European format (thousands separator and decimal comma)
 * @param value - The number to format
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted number string (e.g., "1.234,56")
 */
export function formatNumber(value: number, decimals: number = 2): string {
    return new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(value);
}

/**
 * Formats a number as percentage
 * @param value - The number to format (0-100)
 * @param decimals - Number of decimal places (default: 0)
 * @returns Formatted percentage string (e.g., "85,5%")
 */
export function formatPercentage(value: number, decimals: number = 0): string {
    return new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(value) + '%';
}
